import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';
import { CTAButton, CTALink } from 'listing-details/components/CTA/CTA';

export const MoreInformationWrapper = styled('section')(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;

        ${Heading2} {
            width: 100%;
            margin-bottom: ${theme.spacing['16px']};
        }

        ${CTAButton}, ${CTALink} {
            border: none;
            border-top: 1px solid ${theme.colors['graphic-background-accent']};
            &:last-child {
                border-bottom: 1px solid
                    ${theme.colors['graphic-background-accent']};
            }
        }

        ${theme.mq.medium} {
            flex-direction: row;
            flex-wrap: wrap;
            margin-left: -${theme.spacing['16px']};

            ${CTAButton}, ${CTALink} {
                width: calc(50% - (${theme.spacing['16px']}));
                border: 1px solid ${theme.colors['graphic-background-accent']};
                margin-left: ${theme.spacing['16px']};
                margin-bottom: ${theme.spacing['8px']};
            }

            ${Heading2} {
                margin: ${theme.spacing['24px']} 0 ${theme.spacing['24px']}
                    ${theme.spacing['16px']};
            }
        }

        ${theme.mq.large} {
            margin-left: -${theme.spacing['24px']};

            ${CTAButton}, ${CTALink} {
                width: calc(50% - (${theme.spacing['24px']}));
                margin-left: ${theme.spacing['24px']};
            }

            ${Heading2} {
                margin-left: ${theme.spacing['24px']};
            }
        }
    `
);
